import { render, staticRenderFns } from "./AssessmentSummary.vue?vue&type=template&id=264d57ce&scoped=true"
import script from "./AssessmentSummary.vue?vue&type=script&lang=js"
export * from "./AssessmentSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d57ce",
  null
  
)

export default component.exports